import { render, staticRenderFns } from "./NewsAll.vue?vue&type=template&id=5c156856&scoped=true&"
import script from "./NewsAll.vue?vue&type=script&lang=js&"
export * from "./NewsAll.vue?vue&type=script&lang=js&"
import style0 from "./NewsAll.vue?vue&type=style&index=0&id=5c156856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c156856",
  null
  
)

export default component.exports